const CONFIG = {
	title: 'Zender Live Studio',
	targetsRoot: `https://api.prototoapi.lrt.lt/v1/targets`,
	channelsRoot: `https://api.prototoapi.lrt.lt/v1/channels`,
};

export default CONFIG;



// WEBPACK FOOTER //
// ./src/config/production.js